import { render, staticRenderFns } from "./SpacesView.vue?vue&type=template&id=7588f584&scoped=true&"
import script from "./SpacesView.vue?vue&type=script&lang=js&"
export * from "./SpacesView.vue?vue&type=script&lang=js&"
import style0 from "./SpacesView.vue?vue&type=style&index=0&id=7588f584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7588f584",
  null
  
)

export default component.exports